import React from 'react'
import { useTranslation } from 'react-i18next'
import CommonInput from '../../common/Resusable/CommonInput'

const AWBInputBox = ({
    t,
    awbPrefix,
    setAwbPrefix,
    awbNo,
    setAwbNo,
    error,
    validateAWBPrefix,
    validateAWBDocNo,
    hasError,
    removeError,
    handleGetAwb
}) => {
    const { i18n } = useTranslation();
    const isJapanese = i18n.language === 'ja';

    return (
    <div className="awb-input-box">
        <div className='form-row'>
            <div className='col-12'>
                <h4 className='awb-input-heading mb-0 mt-0'>
                    {t('COMMON.AWB_DTLS')}
                </h4>
            </div>
        </div>
        <div className='portal-row d-flex justify-content-between  awb-input-row'>
            <div className='portal-col'>
                <div className='portal-col'>

                    {/* <div className={`form-group awb-input-section`}>
                        <CommonInput
                           
                            type='text'
                            // className='awb-prefix-input form-item-field'
                            maxLength='3'
                            value={awbPrefix}
                            label={'prefix'}
                            onChange={(e) => {
                                if (e.target.value.length <= 3) {
                                    setAwbPrefix(e.target.value)
                                }
                            }}
                            onBlur={(e) => {
                                validateAWBPrefix(e.target.value)
                            }}
                            aria-invalid={hasError('awbDocumentNo', error)}
                            onFocus={(e) => {
                                removeError(e)
                            }}
                            error={error && error['awbDocumentNo']
                                    ? t(error['awbDocumentNo'], { ns: 'errors' })
                                    : ''}
                            wrapperClassName={`awb-prefix`}
                        />

                        <CommonInput
                              
                                type='number'
                                // className='awb-document-input'
                                maxLength='8'
                                value={awbNo}
                                label={t("COMMON.AWB_NUMBER")}
                                onChange={(e) => {
                                    if (e.target.value.length <= 8) {
                                        setAwbNo(e.target.value)
                                    }
                                }}
                                onBlur={(e) => {
                                    validateAWBDocNo(e.target.value)
                                }}
                                aria-invalid={hasError('awbDocumentNo', error)}
                                onFocus={(e) => {
                                    removeError(e)
                                }}
                             error={error && error['awbDocumentNo']
                                    ? t(error['awbDocumentNo'], { ns: 'errors' })
                                    : ''}
                            wrapperClassName={"awb-suffix"}
                            isOnlyErrorBorder
                        />
                    </div> */}

                    <div className={`awb-combined-input-group ${isJapanese ? 'ja' : ''} ${hasError('awbPrefix', error) || hasError('awbDocumentNo', error) ? 'red-border-bottom' : ''}`}>
                        <div className='awb-prefix-input-wrapper'>
                            <input
                                id='awbPrefix'
                                type='number'
                                className='awb-prefix-input form-item-field'
                                maxLength='3'
                                value={awbPrefix}
                                onChange={(e) => {
                                    if (e.target.value.length <= 3) {
                                        setAwbPrefix(e.target.value)
                                    }
                                }}
                                onBlur={(e) => {
                                    validateAWBPrefix(e.target.value)
                                }}
                                aria-invalid={hasError('awbPrefix', error)}
                                onFocus={(e) => {
                                    removeError(e)
                                }}
                            />
                            <label
                                htmlFor='awbPrefix'
                                className={`floating-label ${awbPrefix ? 'has-value' : ''}`}
                            >
                                {t("COMMON.PREFIX")}
                            </label>
                        </div>
                        <span className="awb-vertical-separator" aria-hidden="true"></span>
                        <div className='awb-document-input-wrapper'>
                            <input
                                id='awbDocumentNo'
                                type='number'
                                className='awb-document-input'
                                maxLength='8'
                                value={awbNo}
                                onChange={(e) => {
                                    if (e.target.value.length <= 8) {
                                        setAwbNo(e.target.value)
                                    }
                                }}
                                onBlur={(e) => {
                                    validateAWBDocNo(e.target.value)
                                }}
                                aria-invalid={hasError('awbDocumentNo', error)}
                                onFocus={(e) => {
                                    removeError(e)
                                }}
                            />
                            <label
                                htmlFor='awbDocumentNo'
                                className={`floating-label ${awbNo ? 'has-value' : ''}`}
                            >
                                {t("COMMON.AWB_NUMBER")}
                            </label>
                        </div>
                    </div>
                    <div className="form-item__error-container">
                    {(error && (error['awbPrefix'] || error['awbDocumentNo'])) && (
                        <span className='form-item__error'>
                            {error['awbPrefix']
                                ? t(error['awbPrefix'], { ns: 'errors' })
                                : error['awbDocumentNo']
                                    ? t(error['awbDocumentNo'], { ns: 'errors' })
                                    : ''}
                        </span>
                    )}
                    </div>
                    
                    {/* <div
                        className={`form-group col-3 col-lg-3 ${hasError('awbPrefix', error) ? "red-border" : ""
                            }`}
                    >
                        <CommonInput
                             id='awbPrefix'
                            type='number'
                            className='form-item__field'
                            maxLength='3'
                            value={awbPrefix}
                            onChange={(e) => {
                                if (e.target.value.length <= 3) {
                                    setAwbPrefix(e.target.value)
                                }
                            }}
                            onBlur={(e) => {
                                validateAWBPrefix(e.target.value)
                            }}
                            aria-invalid={hasError('awbPrefix', error)}
                            onFocus={(e) => {
                                removeError(e)
                            }}
                            error={error && error['awbPrefix']
                                ? t(error['awbPrefix'], { ns: 'errors' })
                                : ''}
                        />
                    </div>             */}

                    {/* <div
                        className={`form-group col-9 col-lg-9 ${hasError('awbDocumentNo', error) ? "red-border" : ""
                            }`}
                    >
                        <CommonInput
                            id='awbDocumentNo'
                            type='number'
                            label={t("COMMON.AWB_NUMBER")}
                            maxLength='8'
                            value={awbNo}
                            onChange={(e) => {
                                if (e.target.value.length <= 8) {
                                    setAwbNo(e.target.value)
                                }
                            }}
                            onBlur={(e) => {
                                validateAWBDocNo(e.target.value)
                            }}
                            aria-invalid={hasError('awbDocumentNo', error)}
                            onFocus={(e) => {
                                removeError(e)
                            }}
                            error={error && error['awbDocumentNo']
                                ? t(error['awbDocumentNo'], { ns: 'errors' })
                                : ''}
                        />
                    </div> */}

                </div>
            </div>
            {/* Desktop view: right aligned */}
            <div className='captureAwb-Go d-none d-lg-flex justify-content-end'>
                <button className='primary-button' onClick={handleGetAwb}>
                    {t('COMMON.GO')}
                </button>
            </div>
            {/* Mobile view: centered with padding */}
            <div className='col-12 d-flex d-lg-none justify-content-center px-3'>
                <button className='primary-button w-100 mt-4' style={{ maxWidth: 220 }} onClick={handleGetAwb}>
                    {t('COMMON.GO')}
                </button>
            </div>
        </div>
    </div>
    
    );
}

export default AWBInputBox